import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/driversActions";
import { useDriversUIContext } from "../DriversUIContext";
import {ModalProgressBar} from "../../../../../_metronic/_partials/controls";

export function DriversDeleteDialog({ show, onHide }) {
  // Drivers UI Context
  const driversUIContext = useDriversUIContext();
  const driversUIProps = useMemo(() => {
    return {
      ids: driversUIContext.ids,
      setIds: driversUIContext.setIds,
      queryParams: driversUIContext.queryParams,
    };
  }, [driversUIContext]);

  // Drivers Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.drivers.actionsLoading }),
    shallowEqual
  );

  // if drivers weren't selected we should close modal
  useEffect(() => {
    if (!driversUIProps.ids || driversUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driversUIProps.ids]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteDrivers = () => {
    // server request for deleting driver by selected ids
    dispatch(actions.deleteDrivers(driversUIProps.ids)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchDrivers(driversUIProps.queryParams)).then(
        () => {
          // clear selections list
          driversUIProps.setIds([]);
          // closing delete modal
          onHide();
        }
      );
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/*begin::Loading*/}
      {isLoading && <ModalProgressBar />}
      {/*end::Loading*/}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Drivers Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete selected drivers?</span>
        )}
        {isLoading && <span>Driver are deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteDrivers}
            className="btn btn-primary btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
